import Input from "@/app/components/ui/Inputs/Input";
import SearchableMultiSelectMenu from "@/app/components/ui/SelectMenus/MultiSelectMenu";
import NonSearchableSelectMenu from "@/app/components/ui/SelectMenus/NonSearchableSelectMenu";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import ToggleWithIcon from "@/app/components/ui/Toggles/ToggleWithIcon";
import { ISelectMenuItemData } from "@/app/components/ui/interface";
import { useCategoryListAPI } from "@/app/hooks/api_hooks/Inventory/useCategoryListAPI";
import { useCouponCategoryAPI } from "@/app/hooks/api_hooks/coupon/useCouponCategoryAPI";
import { useCouponSubCategoryAPI } from "@/app/hooks/api_hooks/coupon/useCouponSubCategoryAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams, useNavigationType } from "react-router-dom";
import { useL1ServiceListAPI } from "@/app/hooks/api_hooks/Inventory/useL1ServiceListAPI";
import { useAddL1ServiceAPI } from "@/app/hooks/api_hooks/configuration/useAddL1ServiceAPI";
import { useConfigurationServiceDetailAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationServiceDetailAPI";
import { IConfigurationListState } from "@/app_redux/reducers/slices/auth/configuration_slice";
import { useUserRoleAPI } from "@/app/hooks/api_hooks/user/useUserRoleAPI";
import { useInventoryProductCatalougeDropdownAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryProductCatalougeDropdownAPI";
import useFormValidations from "@/app/hooks/useFormValidations";
import InputWithFileUpload from "@/app/components/ui/Inputs/InputWithFileUpload";
import { IInventoryCatalogueImage } from "@/api_framework/api_modals/Inventory";
import { useFileToS3LinkGeneratorAPI } from "@/app/hooks/api_hooks/LabReport/useFileToS3LinkGeneratorAPI";
import toast from "react-hot-toast";
import { RxCross2 } from "react-icons/rx";
import RadioGroupComponent from "@/app/components/ui/RadioGroup";
import { useInventoryActiveTaxListAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryActiveTaxListAPI";
import { useServiceBillableAPI } from "@/app/hooks/api_hooks/Inventory/ServiceSetup/useServiceBillableAPI";
import { useConfigurationServiceTypeListAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationServiceTypeListAPI";
import { useUtils } from "@/app/hooks/useUtils";
import MandatoryLabel from "@/app/components/ui/Reusable/MandatoryLabel";
import { useConfigurationServiceOnboardAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationServiceOnboardAPI";
import { useConfigurationServiceUpdateAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationServiceUpdateAPI";
import { IConfigurationServiceOnboardPostBody } from "@/api_framework/api_modals/Configuration";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import clsx from "clsx";
import { PRIMARY_BUTTON } from "@/constants";

export interface IInventoryCatalogueImageWithFile extends IInventoryCatalogueImage {
  image_file?: File;
}

export interface IInventoryBatchFormFields {
  serviceID: string;
  serviceName: string;
  serviceType: string;
  serviceTypeId: string;
  pet_species: string;
  l2Service: string;
  l2ServiceName: string;
  hour: string;
  minute: string;
  appointmentBookable: string;
  category: Array<string | number>;
  vmscategory: string;
  vmscategoryId: string;
  vmsSubcategory: string;
  vmsSubcategoryId: string;
  startValue: number;
  endValue: number;
  documentRequired: string;
  requisities: string;
  comments: string;
  invoiceTnc: string;
  serviceBillable: string;
  hsncode: string;
  cgst: number;
  sgst: number;
  igst: number;
  ugst: number;
  visibleOnVms: boolean;
  serviceImages: FileList | null;
  image_service: IInventoryCatalogueImageWithFile[];
  description: string;
  appVisible: boolean;
  mappedServices: Array<string>;
}

const defaultGeneralValues: IInventoryBatchFormFields = {
  serviceID: null,
  serviceName: null,
  serviceType: null,
  serviceTypeId: null,
  pet_species: null,
  l2Service: null,
  l2ServiceName: null,
  hour: null,
  minute: null,
  appointmentBookable: "no",
  category: [],
  vmscategory: null,
  vmscategoryId: null,
  vmsSubcategory: null,
  vmsSubcategoryId: null,
  startValue: null,
  endValue: null,
  documentRequired: null,
  requisities: null,
  comments: null,
  invoiceTnc: null,
  serviceBillable: "no",
  hsncode: null,
  cgst: null,
  sgst: null,
  igst: null,
  ugst: null,
  visibleOnVms: false,
  serviceImages: null,
  image_service: [],
  description: null,
  appVisible: false,
  mappedServices: [],
};

const GeneralDetailsFormComponent = () => {
  const { getRouteKey } = useRouter();
  const arrayConstants = useArrayConstants();
  const { setVisible } = useModalActions("INVENTORY_SERVICE_CONFIGURE_CITY_MODAL");
  const [params, _setparams] = useSearchParams();
  const [_categoryId, setCategoryId] = useState([]);
  const fetchL1ServiceList = useL1ServiceListAPI();
  const { execute: fetchCategoryList, categoryList } = useCategoryListAPI();
  const { taxList, serviceBillable } = useRouteInfo(getRouteKey("INVENTORY", "id")).routeState.state as IInventoryState;
  const { execute: fetchCategory, serviceCategory } = useCouponCategoryAPI();
  const { execute: fetchSubCategory, serviceSubCategory } = useCouponSubCategoryAPI();
  const { execute: fetchAddService } = useAddL1ServiceAPI();
  const fetchUserRoles = useUserRoleAPI();
  const navigate = useNavigate();
  const { execute: fetchSubserveDetails, serviceDetails } = useConfigurationServiceDetailAPI();
  const routeIdConfig = getRouteKey("CONFIGURATION", "id");
  const { routeState } = useRouteInfo(routeIdConfig);
  const { serviceSetupL1ServiceList } = routeState.state as IConfigurationListState;
  const subserve_id_for_category = params.get("sub_service_id");
  const subserve_id = params.get("sub_service_id");
  const service_id = params.get("service_id");
  const isServiceSetupEditMode = Boolean(service_id || subserve_id);
  const startTimeItem = arrayConstants.overBookingStartTimeItems as ISelectMenuItemData[];
  const startTimeMinuteItem = arrayConstants.serviceMinuteStartTimeMinuteItems as ISelectMenuItemData[];
  const normalizedCategoryList =
    (Array.isArray(categoryList) ? categoryList : []).map((item: any) => ({
      ...item,
      staff_category_id: item?.staff_category_id ?? item?.id,
    })) ?? [];
  const categoryListItem = useSelectMenuReducer(normalizedCategoryList, "staff_category_name", "staff_category_id");
  const serviceItems = useSelectMenuReducer(serviceSetupL1ServiceList, "service_name", "service_id");
  const { execute: fetchServiceTypeList, serviceTypeList } = useConfigurationServiceTypeListAPI();
  const serviceTypeItems = useSelectMenuReducer(serviceTypeList, "service_type_name", "id");
  const [serviceDurationError, setServiceDurationError] = useState(false);
  const couponCategoryItem = useSelectMenuReducer(serviceCategory, "category_name", "id");
  const couponSubCategoryItem = useSelectMenuReducer(serviceSubCategory, "subcategory_name", "subcategory_id");
  const { searchResults: animalItems, execute: fetchAnimals } = useInventoryProductCatalougeDropdownAPI("ANIMAL_TYPE");
  const animalItemsList = useSelectMenuReducer(animalItems, "animal_type", "animal_type_id");
  const { forOnlyNumber, forOnlyNumbersWithDecimal } = useFormValidations();
  const { execute: uploadToS3 } = useFileToS3LinkGeneratorAPI();
  const taxListItems = useSelectMenuReducer(taxList, "hsn_code", "tax_id");
  const serviceBillableItems = useSelectMenuReducer(serviceBillable, "sub_service_name", "sub_service_id");
  const fetchTaxList = useInventoryActiveTaxListAPI();
  const location = useLocation();
  const previousData = location.state;
  const navigationType = useNavigationType();
  const fetchServiceBillable = useServiceBillableAPI();
  const userPermissions = useAppSelector((state) => state.auth?.userPermissions);
  const userAllowedActions: string[] = userPermissions?.role_permission?.actions || [];
  const canEditServiceOnboard =
    userAllowedActions.length === 0 ||
    userAllowedActions.includes("SERVICE_SETUP_ONBOARD") ||
    userAllowedActions.includes("SERVICE_SETUP_ONBOARD_EDIT");
  const canEditGeneral = canEditServiceOnboard;
  const canEditTax = canEditServiceOnboard;
  const { execute: createServiceOnboardAPI } = useConfigurationServiceOnboardAPI();
  const { execute: updateServiceOnboardAPI } = useConfigurationServiceUpdateAPI();
  const storageKey = `generalDetailsData_${service_id || "new"}`;
  const draftIdsStorageKey = "serviceSetupDraftIds";

  const formHook = useForm<IInventoryBatchFormFields>({
    mode: "onChange",
    defaultValues: defaultGeneralValues,
  });
  const watchedServiceName = formHook.watch("serviceName");
  const watchedPetSpecies = formHook.watch("pet_species");
  const watchedStartValue = formHook.watch("startValue");
  const watchedEndValue = formHook.watch("endValue");
  const selectedServiceTypeId = formHook.watch("serviceTypeId");
  const selectedServiceId = formHook.watch("serviceID");
  const selectedServiceName = formHook.watch("serviceName");

  const normalizeToStringArray = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === "string" && item.trim().length > 0);
    }
    if (typeof value === "string" && value.trim().length > 0) {
      return [value];
    }
    return [];
  };

  const getNormalizedValue = (value: unknown): string => (typeof value === "string" ? value.trim().toLowerCase() : "");

  const selectedServiceItem =
    serviceItems?.find((item) => String(item.id) === String(selectedServiceId)) ||
    serviceItems?.find((item) => getNormalizedValue(item.title) === getNormalizedValue(selectedServiceName)) ||
    (selectedServiceName
      ? ({
          id: selectedServiceId ?? selectedServiceName,
          title: selectedServiceName,
        } as ISelectMenuItemData)
      : null);

  const toImageFieldValues = (value: unknown): IInventoryCatalogueImageWithFile[] => {
    return normalizeToStringArray(value).map((url) => ({
      image_url: url,
      image_file: undefined,
    }));
  };

  useEffect(() => {
    if (!service_id && navigationType === "PUSH") {
      sessionStorage.removeItem(storageKey);
      sessionStorage.removeItem(`generalDetailsState_new`);
      sessionStorage.removeItem(`editMode_new`);
      sessionStorage.removeItem(draftIdsStorageKey);
      formHook.reset(defaultGeneralValues);
    }
  }, [service_id, navigationType, formHook, storageKey]);

  const hour = formHook.watch("hour");
  const minute = formHook.watch("minute");
  const vmsCategoryId = formHook.watch("vmscategoryId");
  const serviceID = formHook.watch("serviceID");
  const selectedProviderCategoryIds = (Array.isArray(formHook.watch("category")) ? formHook.watch("category") : []).map(
    (id) => id?.toString(),
  );
  const documentTypeOptions = useUtils()?.DOCUMENT_TYPE_OPTIONS ?? [];

  const imagesServiceFieldFormHook = useFieldArray<IInventoryBatchFormFields, "image_service">({
    control: formHook.control,
    name: "image_service",
  });

  useEffect(() => {
    if (subserve_id && service_id) {
      fetchSubserveDetails(service_id, subserve_id);
    }
  }, [subserve_id, service_id]);

  useEffect(() => {
    const isEditing = Boolean(service_id);
    const storedGeneralDetailsState = sessionStorage.getItem(`generalDetailsState_${service_id || "new"}`);
    if (!isEditing && storedGeneralDetailsState) {
      return;
    }
    if (!serviceDetails) return;
    const api = serviceDetails;
    const serviceImages = toImageFieldValues(api.service_details?.image_url);
    const documentRequired = normalizeToStringArray(api.service_details?.document_url)[0] ?? null;
    formHook.reset({
      ...defaultGeneralValues,
      ...api,
      image_service: serviceImages,
      documentRequired,
    });
  }, [serviceDetails]);

  useEffect(() => {
    fetchCategoryList();
    fetchServiceTypeList();
    fetchCategory();
    fetchUserRoles();
    fetchAnimals();
    fetchTaxList();
  }, []);

  useEffect(() => {
    // In edit mode, wait for the saved service type before fetching.
    // This avoids a race where an initial "all services" request (null type)
    // resolves after the typed request and overwrites the dropdown options.
    if (service_id && !selectedServiceTypeId) {
      return;
    }
    fetchL1ServiceList(selectedServiceTypeId || null);
  }, [selectedServiceTypeId, fetchL1ServiceList, service_id]);

  useEffect(() => {
    if (vmsCategoryId && vmsCategoryId !== "0") {
      fetchSubCategory(vmsCategoryId);
    }
  }, [vmsCategoryId]);

  useEffect(() => {
    if (serviceID && serviceID !== "0") {
      fetchServiceBillable(formHook?.getValues("serviceID"), formHook?.getValues("l2Service"));
    }
  }, [formHook?.getValues("serviceID")]);

  useEffect(() => {
    setServiceDurationError(hour === "00" && minute === "00");
  }, [hour, minute]);

  const parseOptionalNumber = (val: unknown): number | null => {
    if (val === undefined || val === null || val === "") return null;
    const parsed = typeof val === "number" ? val : Number(val);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const parseTaxNumber = (value: unknown): number => {
    if (typeof value === "number" && Number.isFinite(value)) return value;
    if (typeof value === "string" && value.trim().length > 0) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    }
    return 0;
  };

  const extractImageLinks = (images: unknown): string[] => {
    if (!Array.isArray(images)) return [];
    return images
      .map((img: any) => (typeof img?.image_url === "string" && img.image_url ? img.image_url : null))
      .filter((url): url is string => Boolean(url));
  };

  const normalizeDocumentRequired = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === "string" && item.trim().length > 0);
    }
    if (typeof value === "string" && value.trim().length > 0) {
      return [value];
    }
    return [];
  };

  const buildDetailsPayload = (data: IInventoryBatchFormFields): IConfigurationServiceOnboardPostBody => {
    const hasTaxData =
      Boolean(data?.hsncode) ||
      [data?.cgst, data?.igst, data?.sgst, data?.ugst].some(
        (value) => value !== null && value !== undefined && String(value).trim() !== "",
      );
    const taxServiceId = data?.serviceID || service_id || null;
    const taxSubServiceId = data?.l2Service || subserve_id || null;

    return {
      vms_subcategory_id: data?.vmsSubcategoryId,
      service_type_id: data?.serviceTypeId,
      service_details: {
        service_id: data?.serviceID === "" ? null : data?.serviceID,
        service_name: data?.serviceName,
      },
      sub_service_details: {
        sub_service_name: data?.l2ServiceName,
        sub_service_id: data?.l2Service ? data?.l2Service : null,
      },
      is_appointment_type_service: data?.appointmentBookable === "yes",
      pet_weight_range: {
        start_weight: parseFloat(String(data?.startValue)),
        end_weight: parseFloat(String(data?.endValue)),
      },
      prerequisite_details: data?.requisities || null,
      comments: data?.comments || null,
      invoice_tnc: data?.invoiceTnc || null,
      duration: data?.appointmentBookable === "yes" ? { hours: data?.hour, minutes: data?.minute } : null,
      provider_category_ids: Array.isArray(data?.category) ? data.category.map((id) => String(id)) : [],
      pet_species: data?.pet_species || null,
      child_sub_service_ids:
        data?.serviceBillable !== "yes" && Array.isArray(data?.mappedServices) ? data?.mappedServices : [],
      document_required: normalizeDocumentRequired(data?.documentRequired),
      image_url: extractImageLinks(data?.image_service),
      is_service_billable: data?.serviceBillable === "yes",
      description: data?.description || null,
      visible_on_app: data?.appVisible === true,
      visible_on_vms: data?.visibleOnVms === true,
      ...(hasTaxData
        ? {
            tax_details: {
              service_id: taxServiceId || null,
              sub_service_id: taxSubServiceId || null,
              hsn_code: data?.hsncode,
              tax_rate: {
                cgst_percentage: parseTaxNumber(data?.cgst),
                igst_percentage: parseTaxNumber(data?.igst),
                sgst_percentage: parseTaxNumber(data?.sgst),
                utgst_percentage: parseTaxNumber(data?.ugst),
              },
            },
          }
        : {}),
    };
  };

  const onSubmit = async (data: IInventoryBatchFormFields) => {
    const storedDraftIdsRaw = sessionStorage.getItem(draftIdsStorageKey);
    const storedDraftIds = storedDraftIdsRaw ? JSON.parse(storedDraftIdsRaw) : null;
    const isRouteEditMode = Boolean(service_id || subserve_id);
    const existingServiceId = service_id || (!isRouteEditMode ? storedDraftIds?.serviceId : null) || null;
    const existingSubServiceId = subserve_id || (!isRouteEditMode ? storedDraftIds?.subServiceId : null) || null;
    const detailsPayload = buildDetailsPayload(data);
    if (existingServiceId) {
      detailsPayload.service_details.service_id = existingServiceId;
    }
    if (existingSubServiceId) {
      detailsPayload.sub_service_details.sub_service_id = existingSubServiceId;
    }
    if (detailsPayload?.tax_details) {
      if (existingServiceId) detailsPayload.tax_details.service_id = existingServiceId;
      if (existingSubServiceId) detailsPayload.tax_details.sub_service_id = existingSubServiceId;
    }
    const isEditing = Boolean(isRouteEditMode || (existingServiceId && existingSubServiceId));
    const apiResponse = isEditing
      ? await updateServiceOnboardAPI(detailsPayload)
      : await createServiceOnboardAPI(detailsPayload);
    if (!apiResponse?.status) {
      return;
    }

    const subServiceId = data?.l2Service || existingSubServiceId || apiResponse?.subServiceId || null;
    const serviceIdForNext = data?.serviceID || existingServiceId || apiResponse?.message || null;
    if (serviceIdForNext || subServiceId) {
      sessionStorage.setItem(
        draftIdsStorageKey,
        JSON.stringify({
          serviceId: serviceIdForNext || null,
          subServiceId: subServiceId || null,
        }),
      );
    }
    let url = `/app/inventory/service-add?page_step=clinic_pricing`;
    if (serviceIdForNext) {
      url += `&service_id=${serviceIdForNext}`;
    }
    if (subServiceId) {
      url += `&sub_service_id=${subServiceId}`;
    }
    const generalDetailsState = { ...data };
    if (!isEditing) {
      const formData = {
        ...data,
        serviceDetails,
      };
      sessionStorage.setItem(storageKey, JSON.stringify(formData));
      sessionStorage.setItem(`generalDetailsState_${service_id || "new"}`, JSON.stringify(generalDetailsState));
      sessionStorage.setItem(`editMode_${service_id || "new"}`, "true");
    } else {
      sessionStorage.removeItem(storageKey);
      sessionStorage.removeItem(`generalDetailsState_${service_id || "new"}`);
      sessionStorage.removeItem(`editMode_${service_id || "new"}`);
    }
    navigate(url, { state: { generalDetails: { ...generalDetailsState, serviceDetails } } });
  };

  useEffect(() => {
    if (service_id) {
      return;
    }
    const storedData = sessionStorage.getItem(storageKey);
    const storedGeneralDetailsState = sessionStorage.getItem(`generalDetailsState_${service_id || "new"}`);
    const isInEditMode = sessionStorage.getItem(`editMode_${service_id || "new"}`);
    let finalData = {};
    if (isInEditMode && storedGeneralDetailsState) {
      finalData = JSON.parse(storedGeneralDetailsState);
    } else if (storedData) {
      finalData = JSON.parse(storedData);
    }
    if (previousData) {
      finalData = { ...finalData, ...previousData };
    }
    if (Object.keys(finalData).length > 0) {
      formHook.reset(finalData);
    }
  }, [formHook.reset, service_id]);

  useEffect(() => {
    formHook.setValue("category", ["7"]);
  }, []);

  const handleSetMinutes = (item: ISelectMenuItemData) => {
    formHook.setValue("minute", item.title);
    if (item) {
      if (formHook.getValues("hour") === "00" && item.title === "00") {
        formHook.setError("minute", {
          type: "validate",
        });
      }
    }
  };

  const handelCreateService = (item: string) => {
    const selectedServiceTypeId = formHook.getValues("serviceTypeId");
    if (!selectedServiceTypeId) {
      toast.error("Please select Service Type before adding a new Service.");
      return;
    }
    formHook.setValue("serviceName", item);
    fetchAddService(item, selectedServiceTypeId).then(({ status, message }) => {
      if (status) {
        formHook.setValue("serviceID", message);
        fetchL1ServiceList(selectedServiceTypeId);
      }
    });
  };

  useEffect(() => {
    const isEditing = Boolean(service_id);
    const storedGeneralDetailsState = sessionStorage.getItem(`generalDetailsState_${service_id || "new"}`);
    if (!isEditing && storedGeneralDetailsState) {
      return;
    }
    if (serviceDetails) {
      formHook.setValue("serviceID", serviceDetails?.service_details?.service_id);
      formHook.setValue("serviceName", serviceDetails?.service_details?.service_name);
      formHook.setValue("serviceTypeId", serviceDetails?.service_details?.service_type_id || null);
      formHook.setValue("serviceType", serviceDetails?.service_details?.service_type_name || null);
      formHook.setValue("l2Service", serviceDetails?.service_details?.sub_service_id);
      formHook.setValue("l2ServiceName", serviceDetails?.service_details?.sub_service_name);
      formHook.setValue(
        "appointmentBookable",
        serviceDetails?.service_details?.is_appointment_type_service ? "yes" : "no",
      );
      // Load bookable-dependent fields regardless of the saved flag so they show up if the user toggles it on.
      const duration_extract = serviceDetails?.service_details?.duration
        ? serviceDetails?.service_details?.duration?.split(":")
        : [];
      if (duration_extract.length) {
        formHook.setValue("hour", duration_extract[0]);
        formHook.setValue("minute", duration_extract[1]);
      }
      const convertedService = toImageFieldValues(serviceDetails?.service_details?.image_url);
      if (convertedService.length) {
        formHook.setValue("image_service", convertedService);
      }
      formHook.setValue("description", serviceDetails?.service_details?.description);
      formHook.setValue("appVisible", serviceDetails?.service_details?.visible_on_app);
      const documentRequired = normalizeToStringArray(serviceDetails?.service_details?.document_url)[0] ?? null;
      formHook.setValue("documentRequired", documentRequired);
      formHook.setValue("requisities", serviceDetails?.service_details?.prerequisites);
      formHook.setValue("comments", serviceDetails?.service_details?.comments);
      formHook.setValue("invoiceTnc", serviceDetails?.service_details?.invoice_tnc);
      formHook.setValue("pet_species", serviceDetails?.service_details?.pet_species);
      formHook.setValue("startValue", serviceDetails?.service_details?.start_weight);
      formHook.setValue("endValue", serviceDetails?.service_details?.end_weight);
      formHook.setValue("serviceBillable", serviceDetails?.service_details?.is_service_billable ? "yes" : "no");
      formHook.setValue(
        "mappedServices",
        Array.isArray(serviceDetails?.service_details?.child_sub_service_ids)
          ? serviceDetails.service_details.child_sub_service_ids
          : [],
      );
      formHook.setValue(
        "category",
        Array.isArray(serviceDetails?.staff_category_details)
          ? serviceDetails.staff_category_details.map((i) => i?.provider_category_id)
          : [],
      );
      if (serviceDetails?.tax_details) {
        formHook.setValue("hsncode", serviceDetails?.tax_details?.hsn_code);
        formHook.setValue("cgst", serviceDetails?.tax_details?.tax_rate?.cgst_percentage);
        formHook.setValue("igst", serviceDetails?.tax_details?.tax_rate?.igst_percentage);
        formHook.setValue("ugst", serviceDetails?.tax_details?.tax_rate?.utgst_percentage);
        formHook.setValue("sgst", serviceDetails?.tax_details?.tax_rate?.sgst_percentage);
      }
      formHook.setValue(
        "vmscategory",
        serviceDetails?.category_sub_category_details && serviceDetails?.category_sub_category_details?.category_name,
      );
      formHook.setValue(
        "vmscategoryId",
        serviceDetails?.category_sub_category_details && serviceDetails?.category_sub_category_details?.category_id,
      );
      formHook.setValue(
        "vmsSubcategoryId",
        serviceDetails?.category_sub_category_details && serviceDetails?.category_sub_category_details?.sub_category_id,
      );
      formHook.setValue(
        "vmsSubcategory",
        serviceDetails?.category_sub_category_details &&
          serviceDetails?.category_sub_category_details?.subcategory_name,
      );
      formHook.setValue("visibleOnVms", serviceDetails?.service_details?.visible_on_vms);
    }
  }, [serviceDetails, service_id]);

  const handleFilesServiceImageSelected = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files?.length) return;
    const validationError = validateFiles(files);
    if (validationError) return toast.error(validationError);

    const selectedFiles = Array.from(files);
    const startIndex = imagesServiceFieldFormHook.fields.length;

    selectedFiles.forEach((file) => {
      imagesServiceFieldFormHook.append({
        image_file: file,
        image_url: URL.createObjectURL(file),
      });
    });

    for (const [offset, file] of selectedFiles.entries()) {
      const res = await uploadToS3(file, null, "product_setup_catalogue");
      if (res?.status && res.message) {
        imagesServiceFieldFormHook.update(startIndex + offset, {
          image_file: file,
          image_url: res.message,
        });
      }
    }
    formHook.resetField("serviceImages");
  };

  const validateFiles = (files: FileList): string | null => {
    if (!Array.from(files).every((file) => file.size < 5 * 1024 * 1024)) {
      return "Each file must be smaller than 5MB";
    }
    const validTypes = ["image/png", "image/jpeg"];
    if (!Array.from(files).every((file) => validTypes.includes(file.type))) {
      return "Invalid file type. Only JPEG and PNG are allowed.";
    }
    return null;
  };

  const handleCancel = () => {
    // Clear saved state when user cancels without saving
    sessionStorage.removeItem(storageKey);
    sessionStorage.removeItem(`generalDetailsState_${service_id || "new"}`);
    sessionStorage.removeItem(`editMode_${service_id || "new"}`);
    sessionStorage.removeItem(draftIdsStorageKey);
    navigate(`/app/inventory/service-list`);
  };

  useEffect(() => {
    const serviceName = watchedServiceName;
    const pet_species = watchedPetSpecies;
    const startValue = watchedStartValue;
    const endValue = watchedEndValue;
    let combined = "";
    let weightSection = "";
    const getWeightValue = (value: unknown): string | null => {
      if (value === undefined || value === null) return null;
      const trimmedValue = String(value).trim();
      return trimmedValue ? trimmedValue : null;
    };
    const normalizedStartValue = getWeightValue(startValue);
    const normalizedEndValue = getWeightValue(endValue);
    const hasStartValue = normalizedStartValue !== null;
    const hasEndValue = normalizedEndValue !== null;

    if (hasStartValue && hasEndValue) {
      weightSection = `(${normalizedStartValue}kg - ${normalizedEndValue}kg)`;
    } else if (hasStartValue) {
      weightSection = `(more than ${normalizedStartValue}kg)`;
    } else if (hasEndValue) {
      weightSection = `(less than ${normalizedEndValue}kg)`;
    }
    const speciesPart =
      typeof pet_species === "string" && pet_species.trim().toLowerCase() === "all" ? "" : pet_species;
    if (serviceName && speciesPart) {
      combined = `${serviceName} - ${speciesPart}`;
    } else {
      combined = serviceName || speciesPart || "";
    }
    combined = [combined, weightSection].filter(Boolean).join(" ");
    formHook.setValue("l2ServiceName", combined);
  }, [watchedServiceName, watchedPetSpecies, watchedStartValue, watchedEndValue, formHook]);

  return (
    <>
      <div className="bg-white rounded-md p-3">
        <h2 className="text-sm font-semibold">Service Setup</h2>
      </div>
      <div className="px-4 py-4 mt-3 bg-white rounded-md">
        <form onSubmit={formHook.handleSubmit(onSubmit)}>
          <div className="mt-1 flex flex-col gap-4">
            <div>
              <div>
                <p className="text-black text-xs font-normal">
                  Service Type <span className="text-rose-600 text-xs font-normal">*</span>
                </p>
              </div>
              <div className="w-full sm:w-2/5 py-2">
                <SearchableSelectMenu
                  errorMessages={[{ message: "Service Type is required", type: "required" }]}
                  onSelectItem={(item) => {
                    if (item) {
                      const currentServiceTypeId = formHook.getValues("serviceTypeId");
                      const isTypeChanged = String(currentServiceTypeId ?? "") !== String(item.id ?? "");
                      formHook.setValue("serviceType", item.title);
                      formHook.setValue("serviceTypeId", item.id);
                      if (isTypeChanged) {
                        formHook.setValue("serviceName", null);
                        formHook.setValue("serviceID", null);
                      }
                    }
                  }}
                  fieldError={formHook.formState.errors.serviceTypeId}
                  register={formHook.register("serviceTypeId", { required: canEditGeneral })}
                  selectItems={serviceTypeItems}
                  placeholder="Select Service Type"
                  showTooltips={true}
                  showTypedErrors={true}
                  showDropdownIcon={true}
                  withDropDownSearch
                  defaultSelected={
                    formHook.watch("serviceTypeId")
                      ? serviceTypeItems?.find((oc) => oc.id === formHook.watch("serviceTypeId")) || null
                      : null
                  }
                  listBoxClassName="w-full"
                  className="text-gray-800"
                  containerClassName="w-full"
                  readOnly={!canEditGeneral || isServiceSetupEditMode}
                  disabled={!canEditGeneral || isServiceSetupEditMode}
                />
              </div>
            </div>
            <div>
              <div>
                <p className="text-black text-xs font-normal">
                  Service Name <span className="text-rose-600 text-xs font-normal">*</span>
                </p>
              </div>
              <div className="w-full sm:w-2/5 py-2">
                <SearchableSelectMenu
                  errorMessages={[{ message: "Service is required", type: "required" }]}
                  onSelectItem={(item) => {
                    if (item) {
                      formHook.setValue("serviceName", item.title);
                      formHook.setValue("serviceID", item.id);
                    }
                  }}
                  fieldError={formHook.formState.errors.serviceName}
                  register={formHook.register("serviceName", { required: canEditGeneral })}
                  selectItems={serviceItems}
                  placeholder="Select Service"
                  showTooltips={true}
                  showTypedErrors={true}
                  showDropdownIcon={true}
                  withDropDownSearch
                  addAction={
                    !isServiceSetupEditMode && canEditGeneral
                      ? {
                          title: `+ ${"Add"}`,
                          callBack: (item: string) => handelCreateService(item),
                        }
                      : undefined
                  }
                  defaultSelected={selectedServiceItem}
                  listBoxClassName="w-full"
                  className="text-gray-800"
                  containerClassName="w-full"
                  readOnly={!canEditGeneral || isServiceSetupEditMode}
                  disabled={!canEditGeneral || isServiceSetupEditMode}
                />
              </div>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-9">
              <div>
                <div>
                  <p>
                    Pet Species <span className="text-red-400">*</span>
                  </p>
                </div>
                <div className="w-full sm:w-2/8 mt-2">
                  <SearchableSelectMenu
                    errorMessages={[{ message: "Animal Type is required", type: "required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("pet_species", item?.title);
                      }
                    }}
                    fieldError={formHook.formState.errors.pet_species}
                    register={formHook.register("pet_species", { required: canEditGeneral })}
                    selectItems={animalItemsList}
                    placeholder="e.g. Dog"
                    showTooltips={true}
                    showTypedErrors={true}
                    showDropdownIcon={true}
                    withDropDownSearch
                    defaultSelected={animalItemsList?.filter((oc) => oc?.title === formHook.watch("pet_species"))[0]}
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full"
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                </div>
              </div>
              <div>
                <div>
                  <p>Pet Weight in Kg</p>
                </div>
                <div className="w-full sm:w-2/8 mt-2 flex items-center gap-2">
                  <Input
                    className="text-xs"
                    placeholder="Start Value"
                    register={formHook.register("startValue", {
                      required: false,
                      ...forOnlyNumbersWithDecimal.validations,
                      validate: {
                        nonNegative: (value: unknown) => {
                          const parsedValue = parseOptionalNumber(value);
                          return parsedValue === null || parsedValue >= 0;
                        },
                        maxValue: (value: unknown) => {
                          const parsedValue = parseOptionalNumber(value);
                          return parsedValue === null || parsedValue <= 100;
                        },
                        startGreaterThanEnd: (value: unknown) => {
                          const parsedStart = parseOptionalNumber(value);
                          const parsedEnd = parseOptionalNumber(formHook.getValues("endValue"));
                          if (parsedStart === null || parsedEnd === null) {
                            return true;
                          }
                          return parsedStart <= parsedEnd;
                        },
                      },
                    })}
                    fieldError={formHook.formState.errors?.startValue}
                    errorMessages={[
                      forOnlyNumbersWithDecimal.errors,
                      { message: "Start value cannot be negative", type: "nonNegative" },
                      { message: "Start value cannot exceed 100", type: "maxValue" },
                      { message: "Start value cannot be greater than end value", type: "startGreaterThanEnd" },
                      { message: "", type: "required" },
                    ]}
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                  <Input
                    className="text-xs"
                    placeholder="End Value"
                    register={formHook.register("endValue", {
                      required: false,
                      ...forOnlyNumbersWithDecimal.validations,
                      validate: {
                        nonNegative: (value: unknown) => {
                          const parsedValue = parseOptionalNumber(value);
                          return parsedValue === null || parsedValue >= 0;
                        },
                        maxValue: (value: unknown) => {
                          const parsedValue = parseOptionalNumber(value);
                          return parsedValue === null || parsedValue <= 100;
                        },
                        endLessThanStart: (value: unknown) => {
                          const parsedEnd = parseOptionalNumber(value);
                          const parsedStart = parseOptionalNumber(formHook.getValues("startValue"));
                          if (parsedStart === null || parsedEnd === null) {
                            return true;
                          }
                          return parsedEnd >= parsedStart;
                        },
                      },
                    })}
                    fieldError={formHook.formState.errors?.endValue}
                    errorMessages={[
                      forOnlyNumbersWithDecimal.errors,
                      { message: "End value cannot be negative", type: "nonNegative" },
                      { message: "End value cannot exceed 100", type: "maxValue" },
                      { message: "End value must be greater than or equal to start value", type: "endLessThanStart" },
                      { message: "", type: "required" },
                    ]}
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="w-full sm:w-2/12 mt-2">
                <p>Sub-Service Name</p>
              </div>
              <div className="w-full sm:w-2/5 py-2">
                <Input
                  className="text-xs"
                  placeholder="Auto generated"
                  register={formHook.register("l2ServiceName", {
                    required: canEditGeneral,
                  })}
                  fieldError={formHook.formState.errors.l2ServiceName}
                  errorMessages={[]}
                  readOnly={!canEditGeneral || isServiceSetupEditMode}
                  disabled={!canEditGeneral || isServiceSetupEditMode}
                />
              </div>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-5">
              <div>
                <div>
                  <p>Category {subserve_id_for_category ? "" : <span className="text-red-400">*</span>}</p>
                </div>
                <div className="w-full sm:w-64 py-2">
                  <SearchableSelectMenu
                    errorMessages={[{ message: "Category is required", type: "required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("vmscategory", item.title);
                        formHook.setValue("vmscategoryId", item.id);
                      }
                    }}
                    fieldError={formHook.formState.errors.vmscategoryId}
                    register={formHook.register("vmscategoryId", {
                      required: canEditGeneral ? (subserve_id_for_category ? false : true) : false,
                    })}
                    selectItems={couponCategoryItem}
                    placeholder="Select Category"
                    showTooltips={true}
                    showTypedErrors={true}
                    showDropdownIcon={true}
                    withDropDownSearch
                    defaultSelected={couponCategoryItem?.filter((oc) => oc.id === formHook.watch("vmscategoryId"))[0]}
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full"
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                </div>
              </div>
              <div>
                <div>
                  <p>
                    Sub-Category <span className="text-red-400">*</span>
                  </p>
                </div>
                <div className="w-full sm:w-64 py-2">
                  <SearchableSelectMenu
                    errorMessages={[{ type: "required", message: "Sub-Category is required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("vmsSubcategory", item.title);
                        formHook.setValue("vmsSubcategoryId", item.id);
                      }
                    }}
                    fieldError={formHook.formState.errors.vmsSubcategoryId}
                    register={formHook.register("vmsSubcategoryId", {
                      required: canEditGeneral ? true : false,
                    })}
                    selectItems={couponSubCategoryItem}
                    placeholder="Select Sub-Category"
                    showTooltips={true}
                    showTypedErrors={false}
                    showDropdownIcon={true}
                    withDropDownSearch
                    defaultSelected={
                      couponSubCategoryItem?.filter((oc) => oc.id === formHook.watch("vmsSubcategoryId"))[0]
                    }
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full"
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="w-full">
                <p>Document Required</p>
              </div>
              <div className="w-full mt-2">
                <div className="w-full sm:w-2/5">
                  <SearchableSelectMenu
                    errorMessages={[{ message: "", type: "required" }]}
                    onSelectItem={(item) => {
                      formHook.setValue("documentRequired", item?.title || "");
                    }}
                    fieldError={formHook.formState.errors.documentRequired}
                    register={formHook.register("documentRequired", { required: false })}
                    selectItems={documentTypeOptions}
                    placeholder="Select Document Type"
                    showTooltips={true}
                    showTypedErrors={false}
                    showDropdownIcon={true}
                    withReset
                    defaultSelected={
                      documentTypeOptions?.filter((oc) => oc.title === formHook.watch("documentRequired"))[0]
                    }
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full"
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                </div>
              </div>
            </div>
            <div>
              <div>
                <p>Pre-requisities</p>
              </div>
              <div className="mt-2 w-full sm:w-2/5">
                <Input
                  className="text-xs"
                  placeholder="e.g. 3 hours fasting"
                  register={formHook.register("requisities", {
                    required: false,
                  })}
                  fieldError={formHook.formState.errors.requisities}
                  errorMessages={[{ message: "", type: "required" }]}
                  readOnly={!canEditGeneral}
                  disabled={!canEditGeneral}
                />
              </div>
            </div>
            <div>
              <div>
                <p>Comments</p>
              </div>
              <div className="mt-2 w-full sm:w-2/5">
                <Input
                  className="text-xs"
                  placeholder="e.g. Dressing should not licked by pet for next 7 days"
                  register={formHook.register("comments", {
                    required: false,
                  })}
                  fieldError={formHook.formState.errors.comments}
                  errorMessages={[{ message: "", type: "required" }]}
                  readOnly={!canEditGeneral}
                  disabled={!canEditGeneral}
                />
              </div>
            </div>
            <div>
              <div>
                <p>Invoice Tnc</p>
              </div>
              <div className="mt-2 w-full sm:w-2/5">
                <Input
                  className="text-xs"
                  placeholder="Invoice TnC, if required"
                  register={formHook.register("invoiceTnc", {
                    required: false,
                  })}
                  fieldError={formHook.formState.errors.invoiceTnc}
                  errorMessages={[{ message: "", type: "required" }]}
                  readOnly={!canEditGeneral}
                  disabled={!canEditGeneral}
                />
              </div>
            </div>
            <div>
              <div>
                <p>
                  Service Billable <span className="text-red-400">*</span>
                </p>
              </div>
              <div className="mt-3">
                <RadioGroupComponent
                  alignment="horizontal"
                  errorMessages={[]}
                  fieldError={formHook.formState.errors?.serviceBillable}
                  register={formHook.register("serviceBillable")}
                  groupOptions={[
                    { id: "yes", title: "Yes", colorClassName: "text-green-500" },
                    { id: "no", title: "No", colorClassName: "text-red-500" },
                  ]}
                  defaultSelectedId={formHook.watch("serviceBillable")}
                  onRadioChange={(optionId: string) => {
                    formHook.setValue("serviceBillable", optionId as "yes" | "no");
                  }}
                  radioOptionClassName="text-sm w-28"
                  disabled={!canEditGeneral}
                />
              </div>
            </div>
            {formHook.watch("serviceBillable") === "no" && (
              <div className="mt-2">
                <div>
                  <p>
                    Mapped Services for Billing <span className="text-red-400">*</span>
                  </p>
                </div>
                <div className="w-full sm:w-2/5 py-2">
                  <SearchableMultiSelectMenu
                    errorMessages={[]}
                    fieldError={formHook.formState.errors.mappedServices}
                    register={formHook.register("mappedServices", {
                      required: false,
                    })}
                    containerClassName="w-full"
                    showTypedErrors={false}
                    onSelectItem={(items) => {
                      const selectedItems = Array.isArray(items) ? items : [];
                      const categoryIds = selectedItems.map((i) => i.id);
                      const categoryIdsString = selectedItems.map((i) => i.id?.toString());
                      formHook.setValue("mappedServices", categoryIds);
                      setCategoryId(categoryIdsString);
                    }}
                    withSelectAll
                    showTooltips={true}
                    placeholder="Select Mapped Services"
                    defaultSelected={serviceBillableItems?.filter((c) =>
                      Array.isArray(formHook.watch("mappedServices"))
                        ? formHook.watch("mappedServices").includes(c.id)
                        : false,
                    )}
                    selectItems={serviceBillableItems}
                    readOnly={!canEditGeneral}
                    disabled={!canEditGeneral}
                  />
                </div>
              </div>
            )}
            <div className="flex items-center gap-5 mt-2 flex-1">
              <div>
                <p className="text-sm font-semibold">Visible on VMS</p>
              </div>
              <div>
                <ToggleWithIcon
                  onToggleChange={(visibleOnVms) => {
                    if (!canEditGeneral) return;
                    formHook.setValue("visibleOnVms", visibleOnVms);
                  }}
                  toggleState={formHook.watch("visibleOnVms")}
                />
              </div>
            </div>
            <div>
              <div className="mt-2">
                <p>
                  Appointment Bookable <span className="text-red-400">*</span>
                </p>
              </div>
              <div className="mt-3">
                <RadioGroupComponent
                  alignment="horizontal"
                  errorMessages={[]}
                  fieldError={formHook.formState.errors?.appointmentBookable}
                  register={formHook.register("appointmentBookable")}
                  groupOptions={[
                    { id: "yes", title: "Yes", colorClassName: "text-green-500" },
                    { id: "no", title: "No", colorClassName: "text-red-500" },
                  ]}
                  defaultSelectedId={formHook.watch("appointmentBookable")}
                  onRadioChange={(optionId: string) => {
                    formHook.setValue("appointmentBookable", optionId as "yes" | "no");
                  }}
                  radioOptionClassName="text-sm w-28"
                  disabled={!canEditGeneral}
                />
              </div>
            </div>
            {formHook.watch("appointmentBookable") === "yes" && (
              <div>
                <div className="mt-2">
                  <div>
                    <p>
                      Service Duration <span className="text-red-400">*</span>
                    </p>
                  </div>
                  <div className="w-full sm:w-2/6 py-2 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-5">
                    <NonSearchableSelectMenu
                      errorMessages={[{ message: "HH is required", type: "required" }]}
                      onSelectItem={(item) => {
                        if (item) {
                          formHook.setValue("hour", item.title);
                        }
                      }}
                      fieldError={formHook.formState.errors.hour}
                      register={formHook.register("hour", { required: canEditGeneral })}
                      selectItems={startTimeItem}
                      placeholder="HH"
                      showTooltips={false}
                      showTypedErrors={false}
                      showDropdownIcon={true}
                      defaultSelected={startTimeItem?.filter((oc) => oc.title === formHook.watch("hour"))[0]}
                      listBoxClassName="w-full"
                      className="text-gray-800"
                      containerClassName="w-24"
                      readOnly={!canEditGeneral}
                      disabled={!canEditGeneral}
                    />{" "}
                    <NonSearchableSelectMenu
                      errorMessages={[
                        { message: "MM is required", type: "required" },
                        {
                          type: "required",
                          message: "Cannot be 00",
                        },
                      ]}
                      onSelectItem={(item) => {
                        if (item) {
                          handleSetMinutes(item);
                        }
                      }}
                      fieldError={formHook.formState.errors.minute}
                      register={formHook.register("minute", { required: canEditGeneral })}
                      selectItems={startTimeMinuteItem}
                      placeholder="MM"
                      showTooltips={false}
                      showTypedErrors={true}
                      showDropdownIcon={true}
                      defaultSelected={startTimeMinuteItem?.filter((oc) => oc.title === formHook.watch("minute"))[0]}
                      listBoxClassName="w-full"
                      className="text-gray-800"
                      containerClassName="w-24"
                      readOnly={!canEditGeneral}
                      disabled={!canEditGeneral}
                    />{" "}
                  </div>
                </div>
                {serviceDurationError && (
                  <div className="flex items-center">
                    <div className="w-full sm:w-2/12"></div>
                    <div className="w-full sm:w-2/6 flex gap-2">
                      <p className="text-[10px] text-red-500">Invalid Duration</p>
                    </div>
                  </div>
                )}
                <div className="mt-2">
                  <div>
                    <p>
                      Service Provider Category <span className="text-red-400">*</span>
                    </p>
                  </div>
                  <div className="w-full sm:w-2/5 py-2">
                    <SearchableMultiSelectMenu
                      errorMessages={[]}
                      fieldError={formHook.formState.errors.category}
                      register={formHook.register("category", {
                        required: false,
                      })}
                      containerClassName="w-full"
                      showTypedErrors={false}
                      onSelectItem={(items) => {
                        const selectedItems = Array.isArray(items) ? items : [];
                        const categoryIds = selectedItems.map((i) => i.id);
                        const categoryIdsString = selectedItems.map((i) => i.id?.toString());
                        formHook.setValue("category", categoryIds);
                        setCategoryId(categoryIdsString);
                      }}
                      withSelectAll
                      showTooltips={true}
                      placeholder="Select Provider Category"
                      defaultSelected={categoryListItem?.filter((c) =>
                        selectedProviderCategoryIds.includes(c.id?.toString()),
                      )}
                      selectItems={categoryListItem}
                      readOnly={!canEditGeneral}
                      disabled={!canEditGeneral}
                    />
                  </div>
                </div>

                <div className="flex gap-5 items-center">
                  <div>
                    <p>Visible on APP</p>
                  </div>
                  <div className="mt-2">
                    <ToggleWithIcon
                      onToggleChange={(status) => {
                        if (!canEditGeneral) return;
                        formHook.setValue("appVisible", status);
                      }}
                      toggleState={formHook.watch("appVisible")}
                    />
                  </div>
                </div>
                {formHook.watch("appVisible") && (
                  <>
                    <div className="mt-2">
                      <div className="w-full">
                        <p>
                          Service Image <MandatoryLabel label="*" className="text-red-400" />
                        </p>
                      </div>
                      <div className="w-full mt-2 flex">
                        <div className="w-full sm:w-2/5">
                          <InputWithFileUpload
                            variant="DRAG_AND_DROP"
                            fieldError={formHook.formState.errors?.serviceImages ?? {}}
                            register={formHook?.register("serviceImages" as const, {
                              required:
                                !(imagesServiceFieldFormHook?.fields?.length > 0) && formHook.watch("appVisible"),
                              validate: {
                                maxSize: (files: FileList) => {
                                  if (!files?.length) return true;
                                  return (
                                    Array.from(files).every((file) => file.size < 5 * 1024 * 1024) ||
                                    "Each file must be smaller than 5MB"
                                  );
                                },
                                fileType: (files: FileList) => {
                                  if (!files?.length) return true;
                                  const validTypes = ["image/png", "image/jpeg"];
                                  return (
                                    Array.from(files).every((file) => validTypes.includes(file.type)) ||
                                    "Invalid file type"
                                  );
                                },
                              },
                              onChange: () => {
                                setVisible();
                              },
                            })}
                            type="file"
                            onChange={handleFilesServiceImageSelected}
                            onClear={() => {
                              formHook.resetField("serviceImages");
                            }}
                            className="w-full"
                            isMultiple
                            id={"serviceImages"}
                            errorMessages={[{ type: "required", message: "" }]}
                            dragAndDropDescription={{ allowedFormats: ["JPEG", "PNG", "PDF"], maxFileSize: "5MB" }}
                            readOnly={!canEditGeneral}
                            disabled={!canEditGeneral}
                          />
                        </div>
                        <div className="grid grid-cols-4 gap-4 mt-4">
                          {imagesServiceFieldFormHook?.fields?.map((item: any, index) => (
                            <div key={item.id} className="flex items-center gap-8 px-4 py-2 relative w-24 h-24">
                              <img
                                src={
                                  item.image_file && item.image_file instanceof File
                                    ? URL.createObjectURL(item.image_file)
                                    : item.image_url
                                }
                                alt={`uploaded-img-${index}`}
                                className="rounded-md w-full h-full object-cover"
                              />
                              <button
                                type="button"
                                onClick={() => imagesServiceFieldFormHook.remove(index)}
                                className="absolute -top-1 -right-1 bg-white rounded-full shadow p-1"
                              >
                                <RxCross2 className="text-red-500" size={16} />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="mt-5">
                      <div>
                        <p>
                          Description <MandatoryLabel label="*" className="text-red-400" />
                        </p>
                      </div>
                      <div className="w-full sm:w-2/5 mt-2">
                        <textarea
                          required={formHook.watch("appVisible")}
                          value={formHook.watch("description")}
                          className="border-gray-300 border-greay-500 border rounded-md w-full h-32 text-xs"
                          placeholder="e.g. Spa bath by certified groomers & Free vet consult"
                          onChange={(e) => formHook?.setValue("description", e.target.value)}
                          readOnly={!canEditGeneral}
                          disabled={!canEditGeneral}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            <div>
              <div>
                <p className="text-sm font-semibold">
                  Tax Details <span className="text-red-400">*</span>
                </p>
              </div>
              <div>
                <div className="mt-3">
                  <p>
                    HSN Code <span className="text-red-400">*</span>
                  </p>
                </div>
                <div className="w-full sm:w-2/5 mt-2">
                  <SearchableSelectMenu
                    errorMessages={[{ message: "HSN Code is required", type: "required" }]}
                    onSelectItem={(item) => {
                      if (item) {
                        formHook.setValue("hsncode", item.title);
                      }
                    }}
                    fieldError={formHook.formState.errors?.hsncode}
                    register={formHook.register("hsncode", {
                      required: canEditTax,
                    })}
                    selectItems={taxListItems}
                    placeholder="Select HSN Code"
                    showTooltips={true}
                    showTypedErrors={true}
                    showDropdownIcon={true}
                    withDropDownSearch
                    defaultSelected={taxListItems?.filter((oc) => oc?.title === formHook.watch("hsncode"))[0]}
                    listBoxClassName="w-full"
                    className="text-gray-800"
                    containerClassName="w-full"
                    showDropdownWhenNoData={true}
                    readOnly={!canEditTax}
                    disabled={!canEditTax}
                  />
                </div>
              </div>
              <div>
                <div className="mt-5">
                  <p>
                    Tax Details <span className="text-red-400">*</span>
                  </p>
                </div>
                <div className="w-full flex flex-wrap gap-x-6 gap-y-4 mt-2">
                  <div className="min-w-[9rem]">
                    <div className="mt-2">
                      <p>
                        CGST <span className="text-red-400">*</span>
                      </p>
                    </div>
                    <div className="mt-1">
                      <Input
                        className="text-xs w-28"
                        placeholder="CGST %"
                        register={formHook.register("cgst", {
                          required: canEditTax,
                          ...forOnlyNumbersWithDecimal.validations,
                        })}
                        fieldError={formHook.formState.errors?.cgst}
                        errorMessages={[
                          { message: "CGST % is required", type: "required" },
                          forOnlyNumbersWithDecimal.errors,
                          { message: "CGST % cannot be negative", type: "nonNegative" },
                          { message: "CGST % cannot be greater than 100", type: "withinLimit" },
                        ]}
                        readOnly={!canEditTax}
                        disabled={!canEditTax}
                      />
                    </div>
                  </div>
                  <div className="min-w-[9rem]">
                    <div className="mt-3">
                      <p>
                        SGST <span className="text-red-400">*</span>
                      </p>
                    </div>
                    <div>
                      <Input
                        className="text-xs w-28"
                        placeholder="SGST %"
                        register={formHook.register("sgst", {
                          required: canEditTax,
                          ...forOnlyNumbersWithDecimal.validations,
                        })}
                        fieldError={formHook.formState.errors?.sgst}
                        errorMessages={[
                          { message: "SGST % is required", type: "required" },
                          forOnlyNumbersWithDecimal.errors,
                          { message: "SGST % cannot be negative", type: "nonNegative" },
                          { message: "SGST % cannot be greater than 100", type: "withinLimit" },
                        ]}
                        readOnly={!canEditTax}
                        disabled={!canEditTax}
                      />
                    </div>
                  </div>
                  <div className="min-w-[9rem]">
                    <div className="mt-3">
                      <p>
                        IGST <span className="text-red-400">*</span>
                      </p>
                    </div>
                    <div>
                      <Input
                        className="text-xs w-28"
                        placeholder="IGST %"
                        register={formHook.register("igst", {
                          required: canEditTax,
                          ...forOnlyNumbersWithDecimal.validations,
                        })}
                        fieldError={formHook.formState.errors?.igst}
                        errorMessages={[
                          { message: "IGST % is required", type: "required" },
                          forOnlyNumbersWithDecimal.errors,
                          { message: "IGST % cannot be negative", type: "nonNegative" },
                          { message: "IGST % cannot be greater than 100", type: "withinLimit" },
                        ]}
                        readOnly={!canEditTax}
                        disabled={!canEditTax}
                      />
                    </div>
                  </div>
                  <div className="min-w-[9rem]">
                    <div className="mt-3">
                      <p>
                        UTGST <span className="text-red-400">*</span>
                      </p>
                    </div>
                    <div>
                      <Input
                        className="text-xs w-28"
                        placeholder="UTGST %"
                        register={formHook.register("ugst", {
                          required: canEditTax,
                          ...forOnlyNumbersWithDecimal.validations,
                        })}
                        fieldError={formHook.formState.errors?.ugst}
                        errorMessages={[
                          { message: "UTGST % is required", type: "required" },
                          forOnlyNumbersWithDecimal.errors,
                          { message: "UTGST % cannot be negative", type: "nonNegative" },
                          { message: "UTGST % cannot be greater than 100", type: "withinLimit" },
                        ]}
                        readOnly={!canEditTax}
                        disabled={!canEditTax}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-5 justify-end">
              <div className="mt-4">
                <input
                  type="button"
                  className="rounded-md bg-white px-4 py-1.5 w-full font-normal cursor-pointer text-black shadow-sm text-sm border"
                  value="Cancel"
                  onClick={handleCancel}
                />
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  type={canEditServiceOnboard ? "submit" : "button"}
                  disabled={!canEditServiceOnboard}
                  className={clsx(PRIMARY_BUTTON, "w-full sm:w-auto disabled:opacity-60 disabled:cursor-not-allowed")}
                >
                  Save &amp; Next
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default GeneralDetailsFormComponent;
